import React, { useRef } from 'react'
import type { MainMenuProps } from 'iebt-zing-storybook/dist/pages/Layout/NewSidebar'
import {
  SidebarWrapper,
  Sidebar,
  StyledToggleSidebar,
  StyledToggleArrow,
  MainHeader as MainHeaderArea
} from 'iebt-zing-storybook/dist/pages/Layout/NewSidebar/styles'
import { MainHeader } from 'iebt-zing-storybook/dist/pages/Layout/NewSidebar/MainHeader'
import iebtLogo from 'iebt-zing-storybook/dist/assets/images/logo/logo.png'
import collapsedZingLogo from 'iebt-zing-storybook/dist/assets/images/default/Logo Zing curta.png'
import {
  EspacoTeiaSidebarLogoLink,
  EspacoTeiaSidebarLogoImg,
  EspacoTeiaSidebarFooterWrap,
  EspacoTeiaSidebarFooterImg,
  ESPACO_TEIA_SIDEBAR_LOGO_OPEN_URL,
  ESPACO_TEIA_SIDEBAR_LOGO_CLOSED_URL
} from './espacoTeiaBranding.styles'

export const EspacoTeiaNewSidebar = ({
  user: _user,
  isOpen,
  children,
  isOpenHandler,
  isSuperAdmin,
  ...props
}: React.PropsWithChildren<MainMenuProps>): JSX.Element => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const marginLeft = isOpen ? '10px' : '0px'
  const headerLogo = props.isTeiaHeader
    ? undefined
    : isOpen
      ? undefined
      : collapsedZingLogo

  return (
    <>
      <SidebarWrapper
        {...props}
        isOpen={isOpen}
        isSuperAdmin={isSuperAdmin}
        gradientStartColor={props.gradientStartColor}
        gradientStartPercent={props.gradientStartPercent}
        gradientEndColor={props.gradientEndColor}
        gradientEndPercent={props.gradientEndPercent}
        ref={wrapperRef}
        className={`${props.hiddenContent ? 'content-hidden' : ''} ${!isOpen ? 'closed' : ''}`}
      >
        {props.isTeiaHeader ? (
          <MainHeaderArea>
            <EspacoTeiaSidebarLogoLink
              $isOpen={isOpen}
              href="#"
              onClick={(e) => { e.preventDefault() }}
            >
              <EspacoTeiaSidebarLogoImg
                $isOpen={isOpen}
                src={isOpen ? ESPACO_TEIA_SIDEBAR_LOGO_OPEN_URL : ESPACO_TEIA_SIDEBAR_LOGO_CLOSED_URL}
                alt="Espaço TEIA CAIXA"
              />
            </EspacoTeiaSidebarLogoLink>
          </MainHeaderArea>
        ) : (
          <MainHeader logoImg={headerLogo} isOpen={isOpen} isTeiaHeader={props.isTeiaHeader} />
        )}
        <Sidebar>{children}</Sidebar>
        <EspacoTeiaSidebarFooterWrap $marginLeft={marginLeft}>
          <a href="https://iebtinovacao.com.br/" target="_blank" rel="noreferrer">
            <EspacoTeiaSidebarFooterImg $wide={isOpen} src={iebtLogo} alt="IEBT" />
          </a>
        </EspacoTeiaSidebarFooterWrap>
      </SidebarWrapper>
      {!isSuperAdmin && (
        <StyledToggleSidebar isOpen={isOpen} isTeiaHeader={props.isTeiaHeader} onClick={() => { isOpenHandler(!isOpen) }}>
          <StyledToggleArrow size="xs" icon={isOpen ? ['fas', 'chevron-left'] : ['fas', 'chevron-right']} />
        </StyledToggleSidebar>
      )}
    </>
  )
}
